<script>
import { notify } from '@/helpers/notify' 
import {
  required, requiredIf
} from "vuelidate/lib/validators";

export default {
  name: 'Transfer',
  props:[
    "openModal",
    "data"
  ],
   data() {
        return {
            userList:[],
            form:{
                user_id:'',
                amount:''
            },
            submitted: false,
            loading:false,
            acceptableAmount:'',
            divError: false
        };  
    },
    watch:{
        openModal(prop){
            if(prop==1){
               this.$http.post('/users?output=one&fields=id,name')
                .then(response => this.userList = response.data)
            } 
          
            this.acceptableAmount = this.data.amount
        }
    },
  
    validations: {
        form: {
            amount: {
                required: requiredIf(function () {
                   return this.data.unit == 'metre' 
                })
            },
            name: {
                required: requiredIf(function () {
                    return this.data.unit != 'metre'
                })
            },
            user_id: { required },
        },
    },
    methods: {
        handleSubmit() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) { return; } 

            this.$http.post('/stock/depo/transfer', { ...this.form, from: this.data.user_id, stock_group_id:this.data.stock_group_id })
            .then(resp => {
                if(!resp.data.error) this.form = {};

                this.$emit('loadItems');
                return notify.success(resp.data.message)
            })
            
            this.submitted = false;
        },
    
        getGroupList({target}){
            this.$http.get('/stock/group?id=' + target.value)
            .then(response => this.groupList = response.data )
        },
        close(){
            this.$parent.$bvModal.hide('transfer')
        },
        maxSize({ target }){
          
            if(parseFloat(target.value) > parseFloat(this.acceptableAmount)){
                this.divError = true
            }else{
                this.divError = false
            }
        }
  },
};
</script>

<template>
  <b-modal 
        id="transfer"
        title="Depolar Arası Transfer"  
        no-close-on-backdrop 
        hide-footer>
      <form @submit.prevent="handleSubmit">
          <div class="row mb-1 text-center">
            <label class="col-sm-12 col-form-label">Nerden Transfer</label>
            <div class="col-sm-12">
                {{ data.user_name }}
            </div>
        </div>
        <div class="row mb-1 text-center">
            <label class="col-sm-12 col-form-label">Transfer Edilen Stok</label>
            <div class="col-sm-12">
                {{ data.stock_group_name }}
            </div>
        </div>
        <div class="row mb-1 text-center">
            <label class="col-sm-12 col-form-label">Transfer Edilebilecek Maks. Stok</label>
            <div class="col-sm-12">
                {{ data.amount }} {{ data.unit }}
            </div>
        </div>
        <div class="row text-center">
            <div class="col-md-12">
               <i style="font-size:2.5rem" class="text-primary mdi mdi-transfer-down"></i>
            </div>
        </div>
        <div class="row text-center">
            <label class="col-sm-12 col-form-label" for="depo">Nereye Transfer Edilecek</label>
            <div class="col-sm-12">
                <select 
                    class="form-control form-select"  
                    :class="{
                        'is-invalid': submitted && $v.form.user_id.$error,
                    }" 
                    v-model="form.user_id">
                    <option value="">Seçiniz</option>
                    <option :value="user.id" v-for="(user,i) in userList.filter(e=> e.id != data.user_id)" :key="i">{{ user.name }}</option>
                </select>
                <div
                    v-if="submitted && !$v.form.user_id.required"
                    class="invalid-feedback"
                >
                Bu alanı doldurmak zorunludur.
                </div>
            </div>
        </div>
        {{ data }}
       <div class="row text-center" v-if="data.unit == 'metre'">
            <label class="col-sm-12 col-form-label text-capitalize">Kaç {{ data.unit }} Transfer Edilecek</label>
            <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control text-capitalize"
                    :placeholder="data.unit" 
                    v-model="form.amount" 
                    @keyup="maxSize($event)"
                    :class="{'is-invalid':(submitted && $v.form.group.$error) || divError }" 
                />
                <div
                    v-if="submitted && !$v.form.user_id.required"
                    class="invalid-feedback"
                >
                Bu alanı doldurmak zorunludur.
                </div>
                 <div
                    v-if="divError"
                    class="invalid-feedback">
                  Maksimum {{ acceptableAmount }} {{ data.unit }} yazılabilir.
                </div>
            </div>
        </div>
         <div class="row text-center" v-else>
            <label class="col-sm-12 col-form-label text-capitalize">Transfer Edilecek Seri No</label>
            <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control text-capitalize"
                    @keyup="maxSize($event)"
                    :class="{'is-invalid':(submitted && $v.form.group.$error) || divError }" 
                    placeholder="Seri No" 
                    v-model="form.name"
                />
                <div
                    v-if="submitted && !$v.form.user_id.required"
                    class="invalid-feedback"
                >
                Bu alanı doldurmak zorunludur.
                </div>
                <div
                    v-if="divError"
                    class="invalid-feedback">
                    Maksimum {{ acceptableAmount }} {{ data.unit }} yazılabilir.
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <b-button variant="light" @click="close()">Vazgeç</b-button>
            <b-button 
                type="submit" 
                variant="success" 
                class="ms-1"
                >Transfer Et
            </b-button>
        </div>
    </form>
</b-modal>
</template>  